import { SEAFOOD_CATEGORIES, type SeafoodCategory } from "../data/seafood";

// The seafood categories a signed-in visitor said they love, remembered on this device only.
// Storage can throw (private mode), so reads and writes are wrapped and failure means "none".

const KEY = "zenfresh-favourite-categories";

export function readFavourites(): SeafoodCategory[] {
  try {
    const data: unknown = JSON.parse(localStorage.getItem(KEY) ?? "[]");
    return Array.isArray(data) ? SEAFOOD_CATEGORIES.filter((category) => data.includes(category)) : [];
  } catch {
    return [];
  }
}

export function saveFavourites(categories: SeafoodCategory[]) {
  try {
    localStorage.setItem(KEY, JSON.stringify(categories));
  } catch {
    // Ignored on purpose: a lost preference is not worth breaking the page.
  }
}
